import { SubmitType } from '@urbanx/agx-ui-components';

export const shouldStopForSubmissionErrors = (
  errors: string[],
  submitType?: SubmitType,
  submittedCampaignId?: string
) => errors.length > 0 && (submitType !== SubmitType.GeneratePdf || !submittedCampaignId);
